import { Button, Stack, Typography } from '@mui/material';
import { Loader, NamedLayoutBlock } from 'src/components';
import { membershipsLayoutSx } from 'src/pages/Settings/memberships/styles';

type MembershipsStripeBlockerProps = {
  isLoading?: boolean;
  errorMessage?: string | null;
  onGoToStripe?: () => void;
  onRetry?: () => void;
};

export const MembershipsStripeBlocker = ({
  isLoading = false,
  errorMessage = null,
  onGoToStripe,
  onRetry,
}: MembershipsStripeBlockerProps) => {
  const isErrorState = Boolean(errorMessage) && !isLoading;

  return (
    <NamedLayoutBlock
      title="Memberships"
      sx={membershipsLayoutSx}
      BlockContentProps={{ sx: { p: 0, display: 'flex' } }}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <Stack
          p={3}
          alignItems="center"
          justifyContent="center"
          spacing={2}
          height="100%"
          width="100%"
        >
          <Typography variant="h6" align="center">
            {isErrorState ? 'Unable to load Stripe status' : 'Stripe setup is required'}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            {isErrorState
              ? errorMessage
              : 'You must configure Stripe before using memberships preview and configuration.'}
          </Typography>
          {isErrorState ? (
            <Button variant="contained" onClick={onRetry}>
              Retry
            </Button>
          ) : (
            <Button variant="contained" onClick={onGoToStripe}>
              Go to Billing settings
            </Button>
          )}
        </Stack>
      )}
    </NamedLayoutBlock>
  );
};
